/* ==========================================================================
   Fair-Turbo — Liefertermin auf der Produktkarte (ausgelagert 09.08.2026)
   Vorher als <script> im Karten-Snippet, dadurch 48 mal ausgeliefert
   (134 KB Dubletten). Der eingebaute Laufzeitschutz `if (window.FtEta)
   return;` verhinderte nur die Mehrfach-AUSFUEHRUNG, nicht die
   Mehrfach-Uebertragung.
   Wird in layout/theme.liquid einmal mit defer eingebunden.
   ========================================================================== */

(function () {
  if (window.FtEta) return;
  function fill() {
    try {
      /* 07.10.2026 (Teamleitung, Regel der Rechtsabteilung): Datum aus snippets/ft-liefertermin
         (window.ftLiefertermin, im Kopf jeder Seite), damit Karte, Produktseite und Warenkorb dasselbe Ende
         zeigen: Bestelltag plus 3 Werktage (Montag bis Samstag, ohne Sonn- und Feiertage), Berliner Zeit.
         Bis 06.10.2026 rechnete die Karte ab dem nächsten Werktag wie die damalige Kasse (Abgleich 17.08.2026). */
      var L = window.ftLiefertermin;
      if (!L) return;
      var datum = L.fmtKurz(L.bis());
      if (!datum) return;
      /* 02.10.2026: Datum in eigenem Element, damit es auf schmalen Karten nie
         mitten im Datum umbricht („Do., / 08.10.“). Stil: .ft-pc-datum */
      var nodes = document.querySelectorAll('[data-ft-eta]');
      for (var j = 0; j < nodes.length; j++) {
        /* 15.10.2026 abends (Pascal: „lieber sowas wie bei dir oder bei ihnen am …“): „bei Ihnen bis …“, weiter nur das späteste Datum mit „bis“ (Rechtsabteilung 07.10.) */
        nodes[j].textContent = 'bei Ihnen bis ';
        var s = document.createElement('span');
        s.className = 'ft-pc-datum';
        s.textContent = datum;
        nodes[j].appendChild(s);
      }
    } catch (e) { /* im Zweifel bleibt nur die 1–3-Werktage-Zeile stehen */ }
  }
  window.FtEta = { fill: fill };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fill);
  } else {
    fill();
  }
})();
/* v6 08.08.: Punkte-Sync fuer das Karten-Bildkarussell — ein delegierter
   Scroll-Listener (capture, da scroll nicht bubbelt), rAF-gedrosselt. */
(function () {
  if (window.FtPcGal) return;
  window.FtPcGal = true;
  function sync(g) {
    var i = Math.round(g.scrollLeft / Math.max(g.clientWidth, 1));
    var dots = g.parentElement.querySelectorAll('.ft-pc-gallery-dot');
    for (var n = 0; n < dots.length; n++) {
      dots[n].classList.toggle('is-on', n === i);
    }
  }
  function handler(e) {
    var t = e.target;
    if (!t || t.nodeType !== 1 || !t.hasAttribute || !t.hasAttribute('data-ft-gallery')) return;
    if (t.__ftGalRaf) return;
    t.__ftGalRaf = requestAnimationFrame(function () {
      t.__ftGalRaf = null;
      sync(t);
    });
  }
  document.addEventListener('scroll', handler, true);
  /* Fallback: scrollend fasst auch programmatische Spruenge/Snap-Enden sauber. */
  document.addEventListener('scrollend', handler, true);
})();
